import { useState, useEffect, useContext } from "react";
import { List, Icon, Label, Button, Segment, Header } from "semantic-ui-react";
import { Student } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { AuthContext } from "../../../../contexts/AuthContext";
import { ResultsSlide } from "../../MyCourses/MediaShow/TemplatesManager/ResultsSlide";
import "./AcademicHistory.scss";

const studentController = new Student();

export function AcademicHistory(props) {
  const { academicHistory, studentId } = props;
  const { darkLightTheme } = useContext(AuthContext);
  const { accessToken } = useAuth();
  const [view, setView] = useState("weeks");
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);
  const [weeks, setWeeks] = useState([]);

  //const courseName = academicHistory.SyllabuSubjectGrade.Subject.name;

  useEffect(() => {
    if (academicHistory) {
      (async () => {
        try {
          const historyData =
            await studentController.getAcademicHistoryByStudent(
              studentId,
              academicHistory.SyllabuSubjectGrade.id,
              accessToken
            );
          setWeeks(historyData);
        } catch (error) {
          console.error(error);
        }
      })();

      //setWeeks(courseData.weeks)
    }
  }, [studentId, academicHistory.SyllabuSubjectGrade.id, accessToken]);

  const handleWeekClick = (week) => {
    setSelectedWeek(week);
    setView("sessions");
  };

  const handleSessionClick = (session) => {
    setSelectedSession(session);
    setView("session-detail");
  };

  const handleBackToWeeks = () => {
    setSelectedWeek(null);
    setView("weeks");
  };

  const handleBackToSessions = () => {
    setSelectedSession(null);
    setView("sessions");
  };

  // Formatear la fecha si existe
  const formatDate = (dateString) => {
    if (!dateString) return null;

    return new Date(dateString).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Obtener el icono según el estado
  const getStatusIcon = (status) => {
    switch (status) {
      case "Completado":
        return <Icon name="check circle" className="status-icon completed" />;
      case "En progreso":
        return <Icon name="clock" className="status-icon in-progress" />;
      default:
        return <Icon name="eye" className="status-icon pending" />;
    }
  };

  // Obtener la clase CSS según el estado
  const getStatusClass = (status) => {
    switch (status) {
      case "Completado":
        return "completed";
      case "En progreso":
        return "in-progress";
      default:
        return "pending";
    }
  };



  // Renderizar el contenido según la vista actual
  const renderContent = () => {
    if (view === "weeks") {
      return (
        <div className="weeks-container">
          <div className="weeks-list">
            {weeks.map((week) => {
              const statusClass = getStatusClass(week.status);
              return (
                <div
                  key={week.id}
                  className={`week-item ${statusClass}`}
                  onClick={() => handleWeekClick(week)}
                >
                  <div className="week-content">
                    <div className="week-icon-container">
                      {getStatusIcon(week.status)}
                    </div>
                    <div className="week-info">
                      <div className="week-title">
                        S{week.index + 1}: {week.title}
                      </div>
                      <div className="week-progress">
                        Progreso: {week.progress}
                      </div>
                    </div>
                    <div className="week-status-label">
                      <Label className={`status-label ${statusClass}`}>
                        {week.status}
                      </Label>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else if (view === "sessions" && selectedWeek) {
      return (
        <div className="sessions-container">
          <div className="back-button-container">
            <Button className="btn-back" icon basic onClick={handleBackToWeeks}>
              <Icon name="arrow left" />
            </Button>
            <h3 className="content-title">
              {selectedWeek?.title
                ? `Lista de clases de semana "${selectedWeek.title}"`
                : "Cargando..."}
            </h3>
          </div>
          <div className="sessions-list">
            {selectedWeek.sessions.map((session) => (
              <div
                key={session.id}
                className={`week-item ${
                  session.viewed ? "completed" : "pending"
                }`}
                onClick={() => handleSessionClick(session)}
              >
                <div className="week-content">
                  {/* Columna 1: Ícono de estado */}
                  <div className="week-icon-container">
                    <Icon
                      name={session.viewed ? "check circle" : "eye"}
                      className={`status-icon ${
                        session.viewed ? "completed" : "pending"
                      }`}
                    />
                  </div>

                  {/* Columna 2: Nombre y fecha */}
                  <div className="week-info">
                    <div className="week-title">{session.title}</div>
                    {session.viewed && session.viewedAt && (
                      <div className="week-progress">
                        <Icon name="clock" size="small" />
                        Visto el {formatDate(session.viewedAt)}
                      </div>
                    )}
                  </div>

                  {/* Columna 3: Tipo de sesión */}
                  <div className="session-type">
                    <Label
                      className={`type-label ${
                        session.type === "CLASE" ? "class" : "quiz"
                      }`}
                    >
                      {session.type}
                    </Label>
                  </div>

                  {/* Columna 4: Estado de la sesión */}
                  <div className="week-status-label">
                    <Label
                      className={`status-label ${
                        session.viewed ? "completed" : "pending"
                      }`}
                    >
                      {session.viewed ? "Atendido" : "Pendiente"}
                    </Label>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    } else if (view === "session-detail" && selectedSession) {
      if (selectedSession.type === "CUESTIONARIO") {
        // Los resultados ahora vienen en selectedSession.Evaluations
        const evaluationResults = selectedSession.Evaluations && selectedSession.Evaluations.length > 0
          ? selectedSession.Evaluations[0]
          : null;

        return (
          <div className="slides-container">
            <div className="back-button-container">
              <Button
                className="btn-back"
                icon
                basic
                onClick={handleBackToSessions}
              >
                <Icon name="arrow left" />
              </Button>
              <h3 className="content-title">
                {selectedSession?.title ? selectedSession.title : "Cargando..."}
              </h3>
            </div>
            <div className="slides-list">
              {evaluationResults ? (
                <ResultsSlide
                  results={evaluationResults}
                  onOpenCloseConfirm={() => {
                    /* lógica para reintentar o cerrar */
                  }}
                  view="academyHistory"
                />
              ) : (
                <Segment className="no-results" placeholder>
                  <Header icon>
                    <Icon name="clipboard outline" />
                    No hay resultados de evaluación disponibles para este cuestionario
                  </Header>
                </Segment>
              )}
            </div>
          </div>
        );
      } else if (selectedSession.type === "CLASE") {
        return (
          <div className="slides-container">
            <div className="back-button-container">
              <Button
                className="btn-back"
                icon
                basic
                onClick={handleBackToSessions}
              >
                <Icon name="arrow left" />
              </Button>
              <h3 className="content-title">
                {selectedSession?.title
                  ? `Contenido de clase "${selectedSession.title}"`
                  : "Cargando..."}
              </h3>
            </div>
            <div className="slides-list">
              {selectedSession.slides && selectedSession.slides.length > 0 ? (
                selectedSession.slides.map((slide) => (
                  <div
                    key={slide.id}
                    className={`week-item ${
                      slide.viewed ? "completed" : "pending"
                    }`}
                  >
                    <div className="week-content">
                      {/* Columna 1: Ícono de estado */}
                      <div className="week-icon-container">
                        <Icon
                          name={slide.viewed ? "check circle" : "eye"}
                          className={`status-icon ${
                            slide.viewed ? "completed" : "pending"
                          }`}
                        />
                      </div>
                      {/* Columna 2: Nombre del slide */}
                      <div className="week-info">
                        <div className="week-title">
                          {selectedSession.type === "CLASE"
                            ? slide.content.content?.title ||
                              `Slide ${slide.index + 1}`
                            : slide.content.content?.question ||
                              `Pregunta ${slide.index + 1}`}
                        </div>
                      </div>
                      {/* Columna 3: Estado */}
                      <div className="week-status-label">
                        <Label
                          className={`status-label ${
                            slide.viewed ? "completed" : "pending"
                          }`}
                        >
                          {slide.viewed ? "Visto" : "Pendiente"}
                        </Label>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-slides">No hay slides en esta sesión.</div>
              )}
            </div>
          </div>
        );
      }
    }

    return null;
  };

  return (
    <div>
      <div className="academic-history">{renderContent()}</div>
    </div>
  );
}
